var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcasMiniLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 2.68867 9.31133 0 6 0C2.68867 0 0 2.68867 0 6C0 9.31133 2.68867 12 6 12H12V6ZM3.70625 8.87004H5.81795C7.57903 8.87004 8.66277 7.77237 8.66277 5.9483C8.66277 4.12423 7.57903 3.02656 5.81795 3.02656H3.70625V8.87004ZM5.77014 7.69166H5.06093V4.19687H5.7542C6.75826 4.19687 7.30013 4.68114 7.30013 5.9483C7.30013 7.21546 6.75826 7.69166 5.77014 7.69166Z",
    fill: "#583BE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcasMiniLogo);
export default __webpack_public_path__ + "static/media/dcas_mini_logo.d0922d6113759d6230eaec317a79ff7d.svg";
export { ForwardRef as ReactComponent };